// extracted by mini-css-extract-plugin
export default {"fileCard":"FileCard_fileCard__0t5xC","title":"FileCard_title__fhPZs","deleteBtn":"FileCard_deleteBtn__a9zZ1"};